require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./going-to-do-a-better-job.json") })
        }
      }, "path---going-to-do-a-better-job");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---going-to-do-a-better-job!./.cache/json/going-to-do-a-better-job.json
// module id = 519
// module chunks = 231608221292675